import React, {useEffect, useMemo, useState} from 'react';
import {MaterialReactTable, MRT_GlobalFilterTextField, MRT_ToolbarAlertBanner} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import {Button, Checkbox} from "@mui/material";
import FilterUtil from "../../../../../utils/common/FilterUtil";
import {Link} from "react-router-dom";
import selectionTableUtil, {normalizeSelection} from "../../../../../utils/common/SelectionTableUtil";
import MaterialEstimateUnitService from "../../../../../API/orders/estimate/organization/MaterialEstimateUnitService";
import {handlerExport} from "../../../../../pages/common/settings/handlerExport";
import ButtonCreate from "../../../button/ButtonCreate";
import {materialEstimateUnitStates} from "../../../../../data/MaterialEstimateUnitState";
import {HeaderOPTAdditionally} from "../../orders/organization/production/HeaderOPT";
import CellOPTm from "../../orders/organization/production/CellOPTm";


const IssuanceEstimateUnitTable = ({
                                       data, setData, orderId, orderNumber, tableOptions,
                                       tableOptionsHandle, rowSelection, setRowSelection, unitMap, handleModalAlert
                                   }) => {
    const {onRowSelectionChange} = selectionTableUtil(data, setRowSelection)
    const currentSelection = normalizeSelection(rowSelection)

    const columns = useMemo(
        () => [
            {
                id: 'articleNumber',
                header: 'Артикул',
                accessorKey: 'articleNumber',
                minSize: 250,
            },
            {
                id: 'name',
                header: 'Наименование',
                accessorKey: 'name',
                minSize: 600,
                enableEditing: false,
            },
            {
                id: 'unitId',
                header: 'Ед. изм.',
                accessorKey: 'unitId',
                minSize: 5,
                maxSize: 5,
                Cell: ({cell}) => unitMap[cell.getValue()],

            },
            {
                id: 'materialEstimateUnitState',
                header: 'Статус',
                accessorKey: 'materialEstimateUnitState',
                size: 140,
                Cell: ({cell}) => materialEstimateUnitStates[cell.getValue()],
                filterFn: (row, id, filterValue) => {
                    return materialEstimateUnitStates[row.original.materialEstimateUnitState].toLowerCase().includes(filterValue.toLowerCase())
                },
            },
            {
                id: 'note',
                header: 'Заметки',
                accessorKey: 'note',
                maxSize: 200,
            },
            {
                id: 'quantity',
                header: 'Кол.',
                accessorKey: 'quantity',
                minSize: 5,
                maxSize: 5,
                Cell: ({cell, row}) => (
                    <Link
                        to={'/organization/issuance-piece-materials/' + orderId + '/' + encodeURIComponent(orderNumber) + '/' + row.original.id + '/'
                            + row.original.typeMaterial + '/' + encodeURIComponent(row.original.name) + "/" + encodeURIComponent(unitMap[row.original.unitId])}>{cell.getValue().toFixed(3)}</Link>
                ),
            },
            {
                id: 'packaging',
                header: 'Собрано',
                accessorKey: 'packaging',
                size: 8,
                enableEditing: false,
                filterVariant: 'multi-select',
                filterSelectOptions: FilterUtil.statusList,
                minSize: 1,
                grow: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableSorting: false,
                Header: ({column}) => <HeaderOPTAdditionally
                    column={column} height={100}></HeaderOPTAdditionally>,
                filterFn: (row, id, filterValue) => {
                    return FilterUtil.checkStatus(row.getValue(id), filterValue)
                },
                Cell: ({cell, row}) => <Checkbox
                    cell={cell}
                    disabled={true}
                    checked={row.original.packaging}
                    sx={{padding: "7px 12px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                >
                </Checkbox>,

            },
            {
                id: 'issue',
                header: 'Выдано',
                accessorKey: 'issue',
                size: 8,
                enableEditing: false,
                filterVariant: 'multi-select',
                filterSelectOptions: FilterUtil.statusList,
                minSize: 1,
                grow: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableSorting: false,
                Header: ({column}) => <HeaderOPTAdditionally
                    column={column} height={100}></HeaderOPTAdditionally>,
                filterFn: (row, id, filterValue) => {
                    return FilterUtil.checkStatus(row.getValue(id), filterValue)
                },
                Cell: ({cell, row}) => <Checkbox
                    cell={cell}
                    disabled={true}
                    checked={row.original.issue}
                    sx={{padding: "7px 12px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                >
                </Checkbox>,
            },
            {
                id: 'inStock',
                header: 'На складе',
                accessorKey: 'inStock',
                size: 34,
                minSize: 1,
                grow: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableSorting: false,
                Header: ({column}) => <HeaderOPTAdditionally
                    column={column} height={100}></HeaderOPTAdditionally>,
                Cell: ({row, cell}) => {
                    const white = row.original.quantity !== row.original.inStock
                    return <CellOPTm
                        row={row}
                        cell2={cell}
                        green={!white}
                        white={white}
                        bigCell={true}
                        cellEstimate={cell.getValue()}
                    />
                }
            },
            {
                id: 'waitingForDelivery',
                header: 'Ожидает поставки',
                accessorKey: 'waitingForDelivery',
                size: 34,
                minSize: 1,
                grow: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableSorting: false,
                Header: ({column}) => <HeaderOPTAdditionally
                    column={column} height={100}></HeaderOPTAdditionally>,
                Cell: ({row, cell}) => <CellOPTm
                    row={row}
                    cell2={cell}
                    white={true}
                    bigCell={true}
                    cellEstimate={cell.getValue()}
                />
            },
            {
                id: 'executorForApplication',
                header: 'Сформирована закупка',
                accessorKey: 'executorForApplication',
                size: 34,
                minSize: 1,
                grow: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableSorting: false,
                Header: ({column}) => <HeaderOPTAdditionally
                    column={column} height={100}></HeaderOPTAdditionally>,
                Cell: ({row, cell}) => <CellOPTm
                    row={row}
                    cell2={cell}
                    white={true}
                    bigCell={true}
                    cellEstimate={cell.getValue()}
                />
            },
            {
                id: 'waitingForApplication',
                header: 'Ожидает закупки',
                accessorKey: 'waitingForApplication',
                size: 34,
                minSize: 1,
                grow: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableSorting: false,
                Header: ({column}) => <HeaderOPTAdditionally
                    column={column} height={100}></HeaderOPTAdditionally>,
                Cell: ({row, cell}) => <CellOPTm
                    row={row}
                    cell2={cell}
                    white={true}
                    bigCell={true}
                    cellEstimate={cell.getValue()}
                />
            },
            {
                id: 'wait',
                header: 'Ожидает действий',
                accessorKey: 'wait',
                size: 34,
                minSize: 1,
                grow: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableSorting: false,
                Header: ({column}) => <HeaderOPTAdditionally
                    column={column} height={100}></HeaderOPTAdditionally>,
                Cell: ({row, cell}) => <CellOPTm
                    row={row}
                    cell2={cell}
                    white={true}
                    bigCell={true}
                    cellEstimate={cell.getValue()}
                />
            },
            {
                header: 'id',
                accessorKey: 'id',
                enableColumnActions: false,
                enableGrouping: false,
                enableEditing: false,
                size: 2,
            },
        ],
        [data, setData],
    );

    const handleSubmitExport = () => {
        handlerExport(() => MaterialEstimateUnitService.export(orderId, orderNumber), handleModalAlert)
    }
    return (
        <Box sx={{width: '1850px',}}>
            <Box
                sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px"}}
            >
                <ButtonCreate
                    text={"Экспорт"}
                    width={80}
                    icon={false}
                    onClick={handleSubmitExport}
                />
            </Box>
            <MaterialReactTable
                selectAllMode={"all"}
                muiTableContainerProps={{
                    sx: {
                        width: '1850px',
                        maxHeight: rowSelection?.length > 0 ? `calc(100vh - 540px)` : `calc(100vh - 450px)`,
                    }
                }}
                muiToolbarAlertBannerProps={{
                    sx: {
                        backgroundColor: (theme) => theme.palette.primary.light,
                        "& .MuiStack-root": {
                            padding: 0,
                        },
                    }
                }}
                renderTopToolbar={({table}) => {
                    const backgroundBlue = table.getState().grouping.length > 0 || table.getSelectedRowModel().rows.length > 0
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => backgroundBlue ? theme.palette.primary.light : "transparent",
                        "& .MuiStack-root": {
                            padding: "1px",
                            flexDirection: "row-reverse",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: "40px",
                        },
                    }}>
                        <MRT_ToolbarAlertBanner
                            table={{...table, options: {...table.options, rowCount: tableOptions.totalElements}}}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                muiTableBodyCellProps={{
                    sx: {
                        p: '0px 0px 0px 10px',
                        m: '0px 0px 0px 0px',
                        border: "none",
                        "&:after": {
                            display: "none",
                        },
                        "& td:after": {
                            "&:hover": {
                                backgroundColor: "red"
                            }
                        },
                        "&:not(:last-of-type)": {
                            borderRight: '1px solid #EAEBEA',

                        },
                        "&:nth-of-type(n+8)": {
                            padding: 0,
                        },
                        "&:first-of-type": {
                            padding: 0,
                            width: "50px",
                            height: "36px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: (theme) => theme.palette.text.light,
                            "& .MuiButtonBase-root": {
                                borderRadius: "4px",
                                width: "24px",
                                height: "24px",
                                opacity: 1,
                                margin: 0,
                                padding: 0,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                }
                            }
                        },
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }

                        }
                    },
                }}
                muiTableHeadCellProps={({table, column}) => {
                    return ({
                        sx: {
                            border: '1px solid #EAEBEA',
                            backgroundColor: "#F5F6FA",
                            padding: ['mrt-row-select', "mrt-row-actions", "issue", "packaging"].includes(column.id) ? "0 5px" : ["inStock", "waitingForDelivery", "executorForApplication", "waitingForApplication", "wait"].includes(column.id) ? 0 : '0px 0px 0px 10px',
                            verticalAlign: "bottom",
                            "& .Mui-TableHeadCell-Content": {
                                alignItems: "end",
                                "& .Mui-TableHeadCell-Content-Wrapper": {
                                    justifyContent: "center",
                                    display: "flex",
                                },
                                "& .Mui-TableHeadCell-Content-Labels": {
                                    alignItems: "end",


                                    "& span": {
                                        marginBottom: "3px"
                                    }
                                }
                            },
                        },
                    })
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                            '&:nth-of-type(even)': {
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                            },
                        })
                    })
                }}

                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                displayColumnDefOptions={{
                    'mrt-row-select': {
                        size: "50px",
                        grow: false,
                    },
                }}
                columns={columns}
                data={data}
                rowHeight={13}
                columnSpacing={1}
                initialState={{
                    columnVisibility: {
                        id: false,
                    },
                    isFullScreen: false,
                    pagination: {pageIndex: 0, pageSize: 50},
                }}
                onRowSelectionChange={onRowSelectionChange}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                state={{rowSelection: currentSelection, showGlobalFilter: true, pagination: tableOptions,}}
                rowCount={tableOptions.totalElements}
                enableRowSelection={(row) => row.original.blocked !== true}
                getRowId={(originalRow) => originalRow.id}
                selectionPadding={1}
                selectionCss={{
                    backgroundColor: 'lightblue',
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: 'blue',
                    borderRadius: '4px',
                }}
                enableToolbarInternalActions={false}
                localization={MRT_Localization_RU}
            />
        </Box>
    );
};

export default IssuanceEstimateUnitTable;

